import ajax from "../../lib/appfuse-react/core/ajax";

const settingService = {
    findCertificateStandards: async () => {
        const response = await ajax.get('certificationStandards/findAll');
        return response.data;
    }
}

export default settingService;